<template>
  <div>
    <Search></Search>
    <CommonTab></CommonTab>
    <IndexCategory>
      <li v-if="Object.keys(info).length > 0">
        {{ info.storeInfo.store_name }}
      </li>
    </IndexCategory>
    <!-- 商品信息展示 -->
    <ShowGoods :info="info"></ShowGoods>
    <!-- 商品详细展示 -->
    <ShowGoodsDetail :info="info"></ShowGoodsDetail>
  </div>
</template>

<script>
import CommonTab from "@/components/pc/nav/CommonTab";
import IndexCategory from "@/components/pc/nav/IndexCategory";
import Search from "@/components/pc/Search";
import ShowGoods from "@/components/pc/goodsDetail/ShowGoods";
import ShowGoodsDetail from "@/components/pc/goodsDetail/ShowGoodsDetail";
import { getPcProductDetail } from "@api/store";
import { getUserInfo } from "@api/user";
export default {
  name: "GoodsDetail",
  data() {
    return {
      info: {},
      userInfo: {}
    };
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        this.getProductInfo();
      }
    }
  },
  computed: {},
  created() {
    this.getProductInfo();
  },
  mounted() {
    console.log(this.userInfo);
    getUserInfo().then(res => {
      this.userInfo = res.data;
      console.log(this.userInfo);
      if (this.userInfo.certification_type == 1 && !this.userInfo.spread_uid) {
        this.$router.replace("/");
      }
    });
  },
  methods: {
    getProductInfo() {
      const index = this.$route.params.id;
      getPcProductDetail(index).then(res => {
        this.info = res.data;
      });
    }
  },
  components: {
    Search,
    ShowGoods,
    ShowGoodsDetail,
    CommonTab,
    IndexCategory
  }
};
</script>
<style lang="stylus" scoped>
.shop-item-path
  height 38px
  background-color: #f5f5f5
  line-height 38px
  color #2c2c2c
  .shop-nav-container
    margin 0px auto
    width 80%
</style>
